(function () {
    'use strict';

    // @ngInject
    function SettingsSecondLevelNavigationControllerCtor($scope, $injector, $state, AppStates, UsersManager, AuthService, AnalyticsService, ModalService, StatsigService, $window, $timeout) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'SettingsSecondLevelNavigationController';

        this.$state = $state;
        this.AppStates = AppStates;
        this.AuthService = AuthService;
        this.AnalyticsService = AnalyticsService;
        this.ModalService = ModalService;
        this.StatsigService = StatsigService;

        this.user = UsersManager.getCurrUser();

        // prepare the view model
        this.title = $state.$current.data.title;

        // company settings links
        this.navItems = [
            {linkTitleKey: 'Company Brand', stateToGoto: AppStates.root_core_navigation_settings_company_general, dataTestId: 'company-nav-company-brand--link'},
            {linkTitleKey: 'Preferences', stateToGoto: AppStates.root_core_navigation_settings_company_preferences, dataTestId: 'company-nav-preferences--link'},
            {linkTitleKey: 'Integrations', stateToGoto: AppStates.root_core_navigation_settings_company_integrations, dataTestId: 'company-nav-integrations--link'},
            {linkTitleKey: 'Team', stateToGoto: AppStates.root_core_navigation_settings_company_team, dataTestId: 'company-nav-team--link'}
        ];

        $timeout(function() {
            var container = document.querySelector('.company-nav__list');
            var header = document.querySelector('.top-view--js');
        
            function adjustPosition() {
                if (container && header) {
                    var containerRect = container.getBoundingClientRect();
                    var headerHeight = header.getBoundingClientRect().height;
                    if (containerRect.bottom > $window.innerHeight) {
                        var menuSpacingFromHeader = 50;
                        var windowSize = $window.innerHeight;
                        var updatedHeight = windowSize - menuSpacingFromHeader - headerHeight;
                        container.style.height = updatedHeight + 'px';
                    } else {
                        container.style.height = 'auto';
                    }
                } 
                
            };
        
            angular.element($window).on('resize', adjustPosition);
            $scope.$on('$destroy', function() {
                angular.element($window).off('resize', adjustPosition);
            });
            adjustPosition();
        }, 0);
        

        
        // add routes for company owner only
        if (this.user.isCompanyOwner() || this.user.isAccountOwner()) {

            // membership
            if (this.user.shouldShowMembershipToUser()) {

                this.navItems.push({
                    linkTitleKey: 'Membership',
                    stateToGoto: AppStates.root_core_navigation_settings_company_subscription,
                    dataTestId: 'company-nav-membership--link'
                });
            }
            // bank details
            this.navItems.push({
                linkTitleKey: 'Bank Details',
                stateToGoto: AppStates.root_core_navigation_settings_company_bankInfo,
                dataTestId: 'company-nav-bank-details-payments--link'
            });

            // Payment Method
            this.navItems.push({
                linkTitleKey: 'Client Payment Methods',
                stateToGoto: AppStates.root_core_navigation_settings_company_paymentMethod,
                dataTestId: 'company-nav-payment-method--link'
            });
        }

        if (this.user.shouldShowClientPortal()) {
            this.navItems.splice(2, 0, {linkTitleKey: 'Domain &\nClient Portal', stateToGoto:AppStates.root_core_navigation_settings_company_client_portal, dataTestId: 'company-nav-domain-client-portal--link'});
        }

        this.navItems.splice(2, 0, {
            linkTitleKey: 'AI preferences',
            stateToGoto: AppStates.root_core_navigation_settings_company_ai_preferences,
            dataTestId: 'company-nav-ai-preferences--link'
        });

        this.navigationMenuVariant = 'pending';
        StatsigService.isGateEnabled('ng2react-company-settings-navigation').then(function (isEnabled) {
            this.navigationMenuVariant = isEnabled ? 'react' : 'angular';
        }.bind(this));
    }

    Controllers.SettingsSecondLevelNavigationController = Class(Controllers.BaseController, {
        constructor: SettingsSecondLevelNavigationControllerCtor,

        onMenuItemClicked: function onMenuItemClicked(stateToGoto) {
            this.goToState(stateToGoto);
        },

        onUploadIconClick: function onUploadIconClick() {
            this.ModalService.openUploadIconPhotoModal(this.user.company);
        },

        logout: function logout() {
            this.AuthService.logout();
        },

        activeState: function activeState(route) {
            return route === this.$state.current.name;
        },

        findRootIndex: function findMenuItem(item) {
            return item.linkTitleKey === 'Integrations';
        }

    });
}());

